module.exports = __webpack_public_path__ + "static/img/花瓶15.7891579.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/reliefVase/imgs/花瓶15.png
// module id = pt59
// module chunks = 2